/* Dirt King nav redesign: behavior. Spec: nav-redesign/HANDOFF.md */
(function () {
  if (window.__dkNavInit) return;
  window.__dkNavInit = true;

  /* ---------- Shop by Vehicle: model rows are disclosures, ONE open in the whole menu ---------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dknav-veh] button.dknav-veh__model-btn');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var menu = button.closest('[data-dknav-veh]');
    var wasOpen = button.getAttribute('aria-expanded') === 'true';

    menu.querySelectorAll('button.dknav-veh__model-btn[aria-expanded="true"]').forEach(function (other) {
      other.setAttribute('aria-expanded', 'false');
      var list = document.getElementById(other.getAttribute('aria-controls'));
      if (list) list.hidden = true;
    });

    if (!wasOpen) {
      button.setAttribute('aria-expanded', 'true');
      var years = document.getElementById(button.getAttribute('aria-controls'));
      if (years) years.hidden = false;
    }
  });

  /* ---------- Inline header search (snippets/custom-search.liquid) ---------- */
  function setSearchOpen(wrapper, open) {
    var input = wrapper.querySelector('.dknav-search__input');
    var toggle = wrapper.querySelector('.dknav-search__toggle');
    wrapper.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    input.tabIndex = open ? 0 : -1;
    if (open) {
      // Small screens: the field is position:fixed just under the header (the header row
      // clips overflow), so measure where the header ends.
      var row = wrapper.closest('.header__row');
      if (row) wrapper.style.setProperty('--dknav-search-top', Math.round(row.getBoundingClientRect().bottom) + 'px');
      setTimeout(function () {
        input.focus({ preventScroll: true }); // don't let focus scroll the clipped header row
        if (row) row.scrollTop = 0;
      }, 60);
    }
  }

  function closeAllSearches(except) {
    document.querySelectorAll('[data-dknav-search].is-open').forEach(function (wrapper) {
      if (wrapper !== except) setSearchOpen(wrapper, false);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-dknav-search] .dknav-search__toggle');
    if (toggle) {
      event.preventDefault();
      var wrapper = toggle.closest('[data-dknav-search]');
      var input = wrapper.querySelector('.dknav-search__input');
      if (!wrapper.classList.contains('is-open')) {
        closeAllSearches(wrapper);
        setSearchOpen(wrapper, true);
      } else if (input.value.trim() !== '') {
        wrapper.querySelector('form').submit();
      } else {
        setSearchOpen(wrapper, false);
      }
      return;
    }
    if (!event.target.closest('[data-dknav-search]')) closeAllSearches(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-dknav-search].is-open');
    if (!open) return;
    setSearchOpen(open, false);
    open.querySelector('.dknav-search__toggle').focus();
  });

  /* ---------- Gold top-nav item for the section you're in ----------
     Shopify only flags a top-level link active when its own URL matches, and
     "Shop by Vehicle" etc. link to "#". So mark the parent whose menu contains
     a link to the current page. */
  function markCurrentSection() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (!path) return;
    document.querySelectorAll('.menu-list__list-item').forEach(function (item) {
      var match = Array.prototype.some.call(item.querySelectorAll('.menu-list__submenu a[href]'), function (a) {
        return a.pathname && a.pathname.replace(/\/$/, '') === path;
      });
      var top = item.querySelector(':scope > .menu-list__link');
      if (top) top.classList.toggle('dknav-current', match);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markCurrentSection);
  } else {
    markCurrentSection();
  }

  /* ---------- Mobile drawer (snippets/dk-mobile-drawer.liquid) ---------- */
  var drawerState = { root: null, stack: ['root'], lastFocus: null };

  function drawerParts(root) {
    return {
      drawer: root.querySelector('.dknav-m__drawer'),
      burger: root.querySelector('[data-dknav-m-open]'),
      panels: root.querySelectorAll('[data-dknav-panel]')
    };
  }

  function renderPanels(root) {
    var stack = drawerState.stack;
    var container = root.querySelector('.dknav-m__panels');
    if (container) container.scrollLeft = 0;
    drawerParts(root).panels.forEach(function (panel) {
      var i = stack.indexOf(panel.getAttribute('data-dknav-panel'));
      var active = i === stack.length - 1;
      panel.classList.toggle('is-active', active);
      panel.classList.toggle('is-behind', i > -1 && !active);
      panel.inert = !active;
      if (active) panel.scrollTop = 0;
    });
  }

  function openDrawer(root) {
    var p = drawerParts(root);
    drawerState.root = root;
    drawerState.stack = ['root'];
    drawerState.lastFocus = document.activeElement;
    renderPanels(root);
    root.classList.add('is-open');
    p.drawer.inert = false;
    p.drawer.setAttribute('aria-hidden', 'false');
    p.burger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('dknav-lock');
    setTimeout(function () { root.querySelector('.dknav-m__close').focus({ preventScroll: true }); }, 50);
  }

  function closeDrawer() {
    var root = drawerState.root;
    if (!root) return;
    var p = drawerParts(root);
    root.classList.remove('is-open');
    p.drawer.inert = true;
    p.drawer.setAttribute('aria-hidden', 'true');
    p.burger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('dknav-lock');
    if (drawerState.lastFocus && drawerState.lastFocus.focus) drawerState.lastFocus.focus({ preventScroll: true });
    drawerState.root = null;
  }

  function focusPanelStart(root) {
    var active = root.querySelector('[data-dknav-panel].is-active');
    var first = active && active.querySelector('button, a');
    // preventScroll: focusing mid-slide would otherwise scroll the panel container sideways
    if (first) setTimeout(function () {
      first.focus({ preventScroll: true });
      var container = root.querySelector('.dknav-m__panels');
      if (container) container.scrollLeft = 0;
    }, 320);
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    var open = t.closest('[data-dknav-m-open]');
    if (open) { event.preventDefault(); openDrawer(open.closest('[data-dknav-m]')); return; }

    var root = t.closest('[data-dknav-m]');
    if (!root) return;

    if (t.closest('[data-dknav-m-close]')) { event.preventDefault(); closeDrawer(); return; }

    var to = t.closest('[data-dknav-to]');
    if (to) {
      drawerState.stack.push(to.getAttribute('data-dknav-to'));
      renderPanels(root);
      focusPanelStart(root);
      return;
    }

    if (t.closest('[data-dknav-back]')) {
      if (drawerState.stack.length > 1) drawerState.stack.pop();
      renderPanels(root);
      focusPanelStart(root);
      return;
    }

    // Shop by Vehicle: pick a make -> show its models
    var make = t.closest('[data-dknav-make]');
    if (make) {
      var id = make.getAttribute('data-dknav-make');
      var panel = make.closest('[data-dknav-panel]');
      panel.querySelectorAll('[data-dknav-make]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === make ? 'true' : 'false');
      });
      panel.querySelectorAll('[data-dknav-make-group]').forEach(function (g) {
        g.hidden = g.getAttribute('data-dknav-make-group') !== id;
      });
      var hint = panel.querySelector('[data-dknav-make-hint]');
      if (hint) hint.hidden = true;
      return;
    }

    // Model accordion: ONE open at a time across all makes, newest years listed first
    var modelBtn = t.closest('button.dknav-m__model-btn');
    if (modelBtn) {
      var group = modelBtn.closest('[data-dknav-panel]');
      var row = modelBtn.closest('.dknav-m__model');
      var wasOpen = modelBtn.getAttribute('aria-expanded') === 'true';
      group.querySelectorAll('button.dknav-m__model-btn[aria-expanded="true"]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.closest('.dknav-m__model').querySelector('.dknav-m__years').hidden = true;
      });
      if (!wasOpen) {
        modelBtn.setAttribute('aria-expanded', 'true');
        row.querySelector('.dknav-m__years').hidden = false;
        setTimeout(function () { row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 50);
      }
    }
  });

  document.addEventListener('keydown', function (event) {
    var root = drawerState.root;
    if (!root) return;
    if (event.key === 'Escape') { closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    // keep keyboard focus inside the open drawer
    var drawer = root.querySelector('.dknav-m__drawer');
    var focusable = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled])'),
      function (el) { return el.offsetParent !== null && !el.closest('[inert]'); }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  // close the drawer if the window grows to desktop width (site switches at 1200px)
  window.addEventListener('resize', function () {
    if (drawerState.root && window.innerWidth > 1200) closeDrawer();
  });
})();
